// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3Pd8D","filesListContainer":"PosDisputesFiles_filesListContainer__2p7YY","filesButton":"PosDisputesFiles_filesButton__3DK_s"};